import CalendarDay from '@app/state/calendar/CalendarDay';
import CalendarMonth from '@app/state/calendar/CalendarMonth';
import CalendarCalculator from '@app/state/calendar/CalendarCalculator';


export const useMarketStateSnapshotCalendarKeyboardNavigation = () => {

	const nextDay = (selectedCalendarDay: CalendarDay | undefined, setSelectedCalendarDay: (calendarDay: CalendarDay) => any, calendarMonth: CalendarMonth) => {
		if (!!selectedCalendarDay) {
			const nextCalendarMonthDay = CalendarCalculator.nextCalendarMonthDay(selectedCalendarDay.display, calendarMonth);
			if (!!nextCalendarMonthDay) setSelectedCalendarDay(nextCalendarMonthDay);
		}
	};

	const previousDay = (selectedCalendarDay: CalendarDay | undefined, setSelectedCalendarDay: (calendarDay: CalendarDay) => any, calendarMonth: CalendarMonth) => {
		if (!!selectedCalendarDay) {
			const previousCalendarMonthDay = CalendarCalculator.previousCalendarMonthDay(selectedCalendarDay.display, calendarMonth);
			if (!!previousCalendarMonthDay) setSelectedCalendarDay(previousCalendarMonthDay);
		}
	};

	const nextWeek = (selectedCalendarDay: CalendarDay | undefined, setSelectedCalendarDay: (calendarDay: CalendarDay) => any, calendarMonth: CalendarMonth) => {
		if (!!selectedCalendarDay) {
			const nextCalendarMonthDay = CalendarCalculator.nextCalendarMonthWeek(selectedCalendarDay.display, calendarMonth);
			if (!!nextCalendarMonthDay) setSelectedCalendarDay(nextCalendarMonthDay);
		}
	};

	const previousWeek = (selectedCalendarDay: CalendarDay | undefined, setSelectedCalendarDay: (calendarDay: CalendarDay) => any, calendarMonth: CalendarMonth) => {
		if (!!selectedCalendarDay) {
			const nextCalendarMonthDay = CalendarCalculator.previousCalendarMonthWeek(selectedCalendarDay.display, calendarMonth);
			if (!!nextCalendarMonthDay) setSelectedCalendarDay(nextCalendarMonthDay);
		}
	};

	const today = (setSelectedCalendarDay: (calendarDay: CalendarDay) => any, calendarMonth: CalendarMonth) => {
		const todayCalendarMonthDay = CalendarCalculator.todayCalendarMonthDay(calendarMonth);
		if (!!todayCalendarMonthDay) setSelectedCalendarDay(todayCalendarMonthDay);
	};
	const first = (setSelectedCalendarDay: (calendarDay: CalendarDay) => any, calendarMonth: CalendarMonth) => {
		const firstCalendarMonthDay = CalendarCalculator.firstCalendarMonthDay(calendarMonth);
		if (!!firstCalendarMonthDay) setSelectedCalendarDay(firstCalendarMonthDay);
	};

	return {
		nextDay: nextDay,
		previousDay: previousDay,
		today: today,
		first: first,
		nextWeek: nextWeek,
		previousWeek: previousWeek,
	};
};